/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTextarea/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaTextarea({
  children,
  viewPath = "/DesignSystem/TysiaTextarea",
  marginTop = 16,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  maxWidth,
  onMouseEnter,
  onMouseLeave,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  weight,
  backgroundColor,
  autoFocus,
  size,
  dock,
  focused,
  disabled,
  hovered,
  invalid,
  valid,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  height,
  resize,
  placeholder,
  maxLength
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaTextarea.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 weight={weight}
 style={{'--mt-1-ZipogF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-2-ZipogF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-3-ZipogF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZipogF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mw-5-ZipogF': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--bblr-6-ZipogF': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-7-ZipogF': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-8-ZipogF': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-9-ZipogF': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 weight={weight}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 backgroundColor={backgroundColor}
 autoFocus={autoFocus}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 height={height}
 resize={resize}
 placeholder={placeholder}
 maxLength={maxLength}
>
{children}
</Children>
</div>
</React.Fragment>)
}